module.exports = __webpack_public_path__ + "static/media/exo-latin-900.293c0cb6.woff2";